export class DropdownOption {
  public 'id': string
  public 'description': string
  public 'isEnabled': boolean
}
